// const auth = firebase.auth();
// const db = firebase.firestore();
// const storage = firebase.storage();


// var onChange = (objToWatch, onChangeFunction) => {
//     const handler = {
//         set(target, property, value, receiver) {
//             target[property] = value;
//             onChangeFunction();
//             return true;
//         }
//     };
//     return new Proxy(objToWatch, handler);
// };

const FBase = {

    type: 'firebase',
    error: '',
    user: null,

    // init: function (auth, db, storage) {
    //     this.auth = auth;
    //     this.db = db;
    //     this.storage = storage;
    // },
    init: function (firebase) {
        this.auth = firebase.auth();
        this.db = firebase.firestore();
        this.storage = firebase.storage();
        this.firebase = firebase;
    },

    clearMessage: function () {
        this.error = '';
        this.success = '';
    },
    getMessage: function () {
        let msg = this.success || this.error;
        return msg;
    },

    // if (this.user) {
    //     console.log('Login? Really? You already are!', this.user.email);

    // } else {
    //     login2(email, password)
    // }

    registerUser: async function (email, password) {
        this.clearMessage();
        try {
            await this.auth.createUserWithEmailAndPassword(email, password)
        } catch (err) {
            this.error = err.message;
            throw err;
        }
    },




    // testEmitter: function (model) {
    //     // Create listener on (for?) the uploadProgress property (which is an obj).
    //     var progressListener = Listener.create(this.uploadProgress);
    //     console.log(progressListener);
    //     progressListener.onChange(() => {
    //         console.log('changed')
    //     });
    //     progressListener.progress = 345;
    //     console.log(progressListener);
    //     return;
    //     progressListener.onChange(() => {
    //         model.progressListener.set('progress', this.uploadProgress.progress);// = this.uploadProgress.progress;
    //     });

    //     var count = 0;
    //     var tid = setInterval(() => {
    //         count += 2;
    //         // progressListener.progress = count;
    //         progressListener.set('progress', count);
    //         console.log('testEmitter', count);
    //         // this.uploadProgressProxy.progress = count;
    //         if (count >= 10) {
    //             clearInterval(tid);
    //         }
    //     }, 50)
    // },

    // testEmitter_v1_works: function (model) {
    //     this.uploadProgressProxy = onChange(this.uploadProgress, () => {
    //         model.uploadProgressProxy.progress = this.uploadProgress.progress;
    //     });
    //     var count = 0;
    //     var tid = setInterval(() => {
    //         count += 2;
    //         // console.log(this);
    //         // console.log(count)
    //         this.uploadProgressProxy.progress = count;
    //         if (count >= 10) {
    //             clearInterval(tid);
    //         }
    //     }, 50)
    // },

    uploadProgress: {
        progress: 0
    },
    // uploadProgressProxy: {},


    testUploadProgress: function (store) {
        console.log(store);
        return new Promise((res, rej) => {
            var count = 0;
            var tid = setInterval(() => {
                count += 20;
                //this.uploadProgress.progress = count * 10;
                // store.state.uploadProgress = count;
                store.dispatch('setUploadProgress', count);
                console.log(count);
                if (count >= 100) {
                    clearInterval(tid);
                    res(true);
                }
            }, 500)
        })
    },

    uploadTaskRunner: function (task, store) {
        // console.log('task runner task:', task);

        // console.log('uploadTaskRunner - this:', this);
        // return;
        return new Promise((resolve, reject) => {
            // return reject('FAKE UPLOAD ERROR!')
            const self = this;
            task.on('state_changed',
                function (snapshot) {
                    let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    store.dispatch('setUploadProgress', percentage);

                    // console.log("**UPLOAD-PROGRESS", percentage);
                    // self.uploadProgress.progress = percentage;
                },
                function error(err) {
                    //A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    self.error = 'Upload image error: ' + err.code;
                    // console.log(FBase.error);
                    reject(self)

                },
                function () {
                    console.log('Image UPLOADED!');

                    self.success = 'Image successfully uploaded.'
                    // self.uploadedImgUrl = await self.getImageUrl(storagePath + '/' + file.name);


                    resolve(self);
                    // storageRef
                    //     .getDownloadURL()
                    //     .then(url => {
                    //         resolve(url)
                    //     })
                    //     .catch(err => {
                    //         console.log("IMAGE GET URL ERROR:", err);
                    //     });
                }
            )
        })

    },

    // storagePath: Storage path NOT including fileName, e.g. /myimgs/someuserid
    // file: File object representing file selected for upload
    // pixapup: Modified to take in store parameter, i.e. state
    uploadImage: async function (storagePath, file, store, metaDataObj = {}) {
        // console.log('api file.name', file.name.toLowerCase());
        // return;
        this.clearMessage();
        if (!this.user) {
            // console.log('You must be logged in to logout!');
            this.error = 'You must be logged in to upload an image.';
            return;
        }
        // const self = this;
        if (!file) {
            this.error = 'No image file selected for upload.';
            throw this.error;
        }

        var filename = file.name.toLowerCase();
        var storageRef = this.storage.ref(storagePath + '/' + filename);

        // console.log(storageRef);

        // NOTE: THIS structure of metadata works!
        var uploadTask = storageRef.put(file, {
            // customMetadata: {
            //     edit: 'anUploadDocIdSelectedForImageEdit'
            // }
            customMetadata: metaDataObj
        });
        // console.log('uploadTask', uploadTask);

        try {
            // uploadTaskRunner returns 'this' since self is passed to both resolve() and reject() in the runner function
            await this.uploadTaskRunner(uploadTask, store);
            // await storageRef.updateMetadata({ customMetadata: { edit: 'yes-it-is!' } });
        } catch (err) {
            console.error(err.getMessage());
            throw err.getMessage();
        }

    },

    createUserDoc: async function (data) {
        this.clearMessage();
        try {

            data.uid = this.user.uid;
            await this.firebase.functions().httpsCallable('createUser')(data);

            // // ********** UPDATE security rules in Firestore!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // await this.db.collection('users').doc(this.user.uid).set({
            //     fName: data.fName,
            //     lName: data.lName,
            //     agreeTermsPrivacy: true, // bring in via data arg
            //     agreeCookies: true, // bring in via data arg
            //     agreeEmailNotify: false, // bring in via data arg
            //     createdAt: this.firebase.firestore.FieldValue.serverTimestamp(),
            //     enabled: true
            // })
        } catch (err) {
            this.error = err
            throw err;
        }
    },


    // Using .catch() on the signInWithEmailAndPassword method (on auth obj) since this solves the Firebase-level 
    // issue of getting an "Uncaught" console error showing up when there's an FB signin error when using the
    // async/await try/catch pattern.
    // Ref: https://stackoverflow.com/questions/51819349/getting-uncaught-after-catching-error-in-firebase-auth-with-async
    login: function (email, password) {
        this.clearMessage();
        if (this.user) {
            this.error = 'You are already logged in: ' + this.user.email;
            return;
        }

        var errorWithErrorCode = {
            'auth/invalid-email': 'You either did not enter an email address or it\'s badly formatted.',
            // 'auth/user-not-found': `There is no account for a user with this email: ${email}`,
            // 'auth/wrong-password': `Incorrect password for user with this email: ${email}`,
            'auth/user-not-found': `Invalid email/password combination. Please re-enter one or both and try again.`,
            'auth/wrong-password': `Invalid email/password combination. Please re-enter one or both and try again.`,
            'auth/user-disabled': `The account has been disabled. User email: ${email}`,
        }

        var auth = this.auth;
        return new Promise(function (resolve, reject) {
            auth.signInWithEmailAndPassword(email, password)
                .then(cred => resolve(cred))
                .catch(err => reject(errorWithErrorCode[err.code]))
        })
    },

    // For email-password authentication, reauthenticate the user's credentials
    // Note: Can grab the user's email from the current authuser object, but in this implementation the email 
    // is passed in to the method.
    reauthEmPw: async function (email, password) {
        this.clearMessage();
        if (!this.user) {
            this.error = 'You must be logged in to reauthenticate your credentials.';
            return;
        }

        // Get credential for user 
        var cred = this.firebase.auth.EmailAuthProvider.credential(email, password);
        try {
            // returns AuthCredential; in practice, likely claling this method in void context 
            var authCred = await this.user.reauthenticateWithCredential(cred);
            return authCred;
        } catch (err) {
            console.error(err);
            throw err;
        }

    },


    // Call reauthEmPw first to avoid FB possibly throwing error that user needs to logout then login to reauthenticate first.
    // Calling reauthEmPw allows for better UX since clunky having them logout/login; reauthEmPw achieves same thing seamlessly.
    setUserEmail: async function (newEmail) {
        try {
            await this.user.updateEmail(newEmail);
        } catch (err) {
            console.error(err);
            throw err;
        }
    },

    // Call reauthEmPw first to avoid FB possibly throwing error that user needs to logout then login to reauthenticate first.
    // Calling reauthEmPw allows for better UX since clunky having them logout/login; reauthEmPw achieves same thing seamlessly.
    setUserPassword: async function (newPassword) {
        try {
            await this.user.updatePassword(newPassword);
        } catch (err) {
            console.error(err);
            throw err;
        }
    },


    sendUserResetPasswordEmail: async function (email) {
        try {
            await this.auth.sendPasswordResetEmail(email);
        } catch (err) {
            console.error(err);
            throw err;
        }
    },


    logout: async function () {
        this.clearMessage();
        if (!this.user) {
            // console.log('You must be logged in to logout!');
            this.error = 'You must be logged in to logout!';
            return;
        }
        try {
            const email = this.user.email;
            await this.auth.signOut();
            this.success = 'You have logged out: ' + email;
            //console.log('You have logged out:', email);

        } catch (err) {
            this.error = 'Logout error: ' + err;
            //console.log('Logout error:', err)
        }
    },
    checkLoginStatus: function () {
        this.clearMessage();
        if (this.user) {
            this.success = 'User logged in: ' + this.user.email;
        } else {
            this.success = 'User NOT logged in.';
        }
    },

    // Create document in Firebase Firestore with 'add' (as opposed to 'set'), i.e. doc id generated server-side
    addDocument: async function (collection, dataObj) {
        this.clearMessage();
        try {
            var docRef = await this.db.collection(collection).add(dataObj);
            this.success = `addDocument success: Collection: ${collection}. Doc ID: ${docRef.id}`;
            return docRef;
        } catch (err) {
            this.error = err
            throw err;
        }
    },

    // Create document in Firebase Firestore with 'set' (as opposed to 'add'), i.e. doc id needs to be specified
    setDocument: async function (collection, docId, data) {
        this.clearMessage();
        try {
            await this.db.collection(collection).doc(docId).set(data);
            this.success = `setDocument success: Collection: ${collection}. Doc ID: ${docId}`;
            console.log(this.success);
        } catch (err) {
            this.error = err
            throw err;
        }
    },

    // Delete document in Firebase Firestore 
    deleteDocument: async function (collection, docId) {
        this.clearMessage();
        try {
            await this.db.collection(collection).doc(docId).delete(); // delete() returns undefined
            this.success = 'Document deleted.';
        } catch (err) {
            this.error = err;
        }
    },

    getImageUrl: async function (pathToStoredImage) {
        var imgRef = this.storage.ref(pathToStoredImage);
        // console.log('imgRef', imgRef);
        let url = '';
        try {
            url = await imgRef.getDownloadURL();
        } catch (err) {
            url = 'error';
            this.error = err.message;
            console.log('GET-IMG ERROR:', err.message);
        }
        return url;
    },

    // Query a collection of documents.
    // Param: object: {collection: 'nameOfCollection', where:[{query object}]}
    //  Query object: {field:fieldname, op:operator, value:valueToSearchFor}
    //  -->> The 'where' key value can be a single query object or an array of query objects (for compound querying)
    // To have a query with NO 'where' statement, 'where' key value can be an empty string, empty array, or the key can be non-existent.
    queryCollection: async function (obj) {
        this.clearMessage();
        try {
            // const { field, op, value } = obj.where;

            // console.log(this.db.collection(obj.collection));
            // console.log(this.db.collection(obj.collection)['where'](field, op, value));

            // let stmt = this.db.collection(obj.collection)['where'](field, op, value)

            // stmt = this.db.collection("TESTimageUploads").where("breed", "==", 'Border Collie').where("uid", "==", this.user.uid)

            let stmt = this.db.collection(obj.collection);

            var where = obj.where;
            var orderby = obj.orderby;

            // If obj doesn't have a 'where' key, then 'where' (from above assignment) is undefined. If that's the case, set where to empty array.
            if (where === undefined) {
                where = [];
            }
            // If just a single object passed in as the value of the 'where' property, turn it into a single-element array
            if (!Array.isArray(where)) {
                where = [where];
            }

            // If obj doesn't have a 'orderby' key, then 'orderby' (from above assignment) is undefined. If that's the case, set orderby to empty array.
            if (orderby === undefined) {
                orderby = [];
            }
            // If just a single object passed in as the value of the 'orderby' property, turn it into a single-element array
            if (!Array.isArray(orderby)) {
                orderby = [orderby];
            }

            where.forEach(q => {
                var {
                    field,
                    op,
                    value
                } = q;
                stmt = stmt['where'](field, op, value);
            })

            orderby.forEach(o => {
                var {
                    field,
                    sortOrder
                } = o;
                stmt = stmt['orderBy'](field, sortOrder);
            })
            // stmt.orderBy('creTime', 'desc');
            // console.log('stmt', stmt);

            const querySnapshot = await stmt.get();
            // var querySnapshot = await this.db.collection(obj.collection).where(field, op, value).get();
            return querySnapshot;
        } catch (err) {
            // console.log(err);
            this.error = err;
        }
    },



    // New (pixapup) 
    deleteUpload: async function (uploadId) {
        // try {
        // On success, returns string 'ok'; otherwise, throws error
        await this.firebase.functions().httpsCallable('deleteUpload')({
            id: uploadId
        });

        // } catch (err) {
        //     throw err;
        // }
    },


    // New (pixapup) ... testing (or, may become perm)
    docExists: async function (collection, docId) {
        var docRef = this.db.collection(collection).doc(docId);
        var doc = await docRef.get();
        if (doc.exists) {
            return doc;
        }
        return false
    },


    // New (pixapup)
    getDocRefById: function (collection, docId) {
        return this.db.collection(collection).doc(docId);
    },
    getDocById: async function (collection, docId) {
        try {
            // console.log(docRef, collection, docId)
            var docRef = this.getDocRefById(collection, docId);
            var doc = await docRef.get();
            if (doc.exists) {
                return doc;
            }
            throw new Error(`getDocById: Document (id = ${docId}) does not exist in collection (${collection})`);
        } catch (err) {
            console.error(err);
            throw err;
        }
    },

    // New (pixapup)
    // Simple function: Set up document listener for a doc with docId in collection.
    // Don't store it or do anything else ...just create it and return it.
    createDocListener: async function (collection, docId, cbFunction) {
        try {
            var docRef = this.db.collection(collection).doc(docId);
            var doc = await docRef.get();
            if (doc.exists) {
                return docRef.onSnapshot(cbFunction);
            }
            throw new Error(`createDocListener: Document (id = ${docId}) does not exist in collection (${collection})`);
        } catch (err) {
            console.error(err);
            throw err;
        }
    },


    // storeHere: Reference to object that will store the listener (so it can be detached when no longer needed)
    setDocumentListener: async function (collection, docId, cb, storeHere, prop) {
        // this.db.collection(collection).doc(docId).onSnapshot(cb);
        try {
            var docRef = this.db.collection(collection).doc(docId);
            var doc = await docRef.get();
            if (doc.exists) {
                if (storeHere && prop) {
                    storeHere[prop] = docRef.onSnapshot(cb);
                }
            }
        } catch (err) {
            console.error(err);
            throw err;
            // console.error(err);
        }

    },

    onAuthStateChanged: function (fn) {
        this.auth.onAuthStateChanged(fn)
    }
}



// auth.onAuthStateChanged(function (user) {
//     if (user) {
//         // User is signed in.
//         FBase.user = user;
//     } else {
//         // User is signed out.
//         FBase.user = null;
//     }
// });

export default FBase;